import React from "react"
import { twMerge } from "tailwind-merge"
import { Link } from "gatsby"

const H1 = props => {
  return (
    <h1
      className={twMerge([
        "mt-4 text-4xl font-extrabold leading-10 tracking-tight text-slate-900 sm:mt-5 sm:text-5xl sm:leading-none md:text-6xl lg:text-5xl xl:text-6xl",
        props.className,
      ])}
    >
      {props.children}
    </h1>
  )
}
const H2 = props => {
  return (
    <h2
      id={props.id}
      className={twMerge([
        "mt-4 text-3xl font-extrabold leading-9 tracking-tight text-slate-900 sm:mt-5 sm:text-4xl sm:leading-10",
        props.className,
      ])}
    >
      {props.children}
    </h2>
  )
}
const H3 = props => {
  return (
    <h3
      className={twMerge([
        "mt-4 text-2xl font-extrabold leading-8 tracking-tight text-slate-900 sm:mt-5 sm:text-3xl sm:leading-9",
        props.className,
      ])}
    >
      {props.children}
    </h3>
  )
}
const H4 = props => {
  return (
    <h4
      id={props.id}
      className={twMerge([
        "mt-4 text-base font-semibold uppercase leading-6 text-slate-900 sm:mt-5 sm:text-lg",
        props.className,
      ])}
    >
      {props.children}
    </h4>
  )
}
const H5 = props => {
  return (
    <h5
      className={twMerge([
        "mt-1 text-base font-semibold uppercase leading-6 tracking-wide text-blue-600 sm:mt-2 sm:text-lg xl:leading-7",
        props.className,
      ])}
    >
      {props.children}
    </h5>
  )
}
const H6 = props => {
  return (
    <h6
      className={twMerge([
        "mt-1 text-sm font-semibold uppercase leading-5 tracking-wider text-blue-600 sm:mt-2",
        props.className,
      ])}
    >
      {props.children}
    </h6>
  )
}

// prodhero Components
const BlackTitle = props => {
  return (
    <H2 className="mt-0 text-center sm:mt-0 lg:text-left">{props.children}</H2>
  )
}
const BlueSub = props => {
  return (
    <span
      className={twMerge([
        "mt-3 block text-center text-blue-600 lg:inline-block lg:text-left",
        props.className,
      ])}
    >
      {props.children}
    </span>
  )
}

//Body element basics
const P = props => {
  return (
    <p
      className={twMerge([
        props.hero
          ? "mt-4 leading-6 text-slate-600 sm:mt-6 sm:text-lg sm:leading-7 md:text-xl"
          : "t-2 max-w-4xl text-base leading-6 text-slate-600 sm:mt-3",
        props.notice &&
          "mb-8 rounded-md border border-amber-500 bg-amber-300 px-4 py-3 text-sm text-amber-800",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}

const Disclaimer = props => {
  return (
    <p
      className={twMerge([
        "mt-3 text-xs font-extralight leading-normal text-slate-500 sm:mt-4",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}
const Caption = props => {
  return (
    <p
      className={twMerge([
        "text-center text-xs font-normal leading-normal text-slate-600",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}
const A = props => {
  return (
    <Link className="underline hover:no-underline" to={props.to}>
      {props.children}
    </Link>
  )
}

const Ol = props => {
  return (
    <ol
      className={twMerge(["mt-2 list-decimal pl-5 sm:mt-3", props.className])}
    >
      {props.children}
    </ol>
  )
}
const Ul = props => {
  return (
    <ul className={twMerge(["mt-2 list-disc pl-5 sm:mt-3", props.className])}>
      {props.children}
    </ul>
  )
}
const Li = props => {
  return (
    <li
      id={props.id}
      className={twMerge([
        "mb-2 text-base leading-6 text-slate-600 last-of-type:mt-0",
        props.className,
      ])}
    >
      {props.children}
    </li>
  )
}
export {
  H1,
  H2,
  H3,
  H4,
  H5,
  H6,
  BlackTitle,
  BlueSub,
  P,
  Disclaimer,
  Caption,
  A,
  Ol,
  Ul,
  Li,
}
